<template>
  <div class="answeredQuestion">
    <label>{{ result.question.label }}</label>
    <div>
      <span class="oui" v-if="result.answerQuizz === true">Oui</span>
      <span class="non" v-if="result.answerQuizz === false">Non</span>
      <span v-if="result.answerQuizz === null">?</span>
    </div>
    <div>
      <span class="oui" v-if="result.answerUser === true">Oui</span>
      <span class="non" v-if="result.answerUser === false">Non</span>
      <span v-if="result.answerUser === null">?</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuizzResult",
  props: ["result"]
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/quizz.scss";
</style>
